import { Link } from "react-router-dom";
import { STATES_SEO, truncate } from "../../seo/explore-data";
import { PageSeo, Crumbs, CtaBlock, Disclaimer } from "./ExploreBits";

export default function StatesIndex() {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10" data-testid="states-index-page">
      <PageSeo title="State-wise Solar & Wind Project Approval Roadmaps in India | RegNav"
        description={`Regulatory approval roadmaps for power projects in ${STATES_SEO.length} Indian states — STU, discom, nodal agency, CEIG, open access, banking and net-metering rules.`}
        path="/states/" />
      <Crumbs items={[{ name: "Home", to: "/" }, { name: "States" }]} />
      <h1 className="font-serif text-3xl sm:text-4xl text-[#0B1F3A]">State-wise approval roadmaps</h1>
      <p className="text-sm text-[#475569] mt-3 max-w-2xl">The state agencies, open-access and banking rules, net-metering caps and state-specific steps for power projects in {STATES_SEO.length} Indian states.</p>
      <div className="grid sm:grid-cols-2 gap-4 mt-8">
        {STATES_SEO.map((s) => (
          <Link key={s.slug} to={`/states/${s.slug}`} className="block bg-white border border-[#0B1F3A]/10 rounded-xl px-5 py-4 card-lift" data-testid={`state-card-${s.slug}`}>
            <h3 className="font-serif font-semibold text-[#0B1F3A]">{s.name}</h3>
            <p className="text-xs text-[#475569] mt-1.5">STU: {s.stu} · Nodal: {s.nodal} · Regulator: {s.erc}</p>
            <p className="text-[11px] text-[#475569] mt-2">{truncate(s.extra, 110)}</p>
          </Link>
        ))}
      </div>
      <CtaBlock />
      <Disclaimer />
    </div>
  );
}
